import { apiUrl } from '.';
import { authService } from './';

const addLocation = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations', requestOptions);
    return res;
}

const editLocation = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations', requestOptions);
    return res;
}

const editInfoLocation = async (id) => {
    const res = await authService.handleResponse(apiUrl + '/configuration/locations/?id=' + id, {
        method: 'GET'
    });
    return res;
}

const addLocationSpecies = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations/species', requestOptions);
    return res;
}

const editLocationSpecies = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations/species', requestOptions);
    return res;
}

const locationStatus = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations/status', requestOptions);
    return res;
}

const locationSpeciesStatus = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations/species/status', requestOptions);
    return res;
}

const getLocations = async (id) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/locations', requestOptions);
    return res;
}

const addTask = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/tasks', requestOptions);
    return res;
}

const editTask = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/tasks', requestOptions);
    return res;
}

const taskStatus = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/tasks/status', requestOptions);
    return res;
}

const getTasks = async (id) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/tasks', requestOptions);
    return res;
}

const getUsers = async (page, status, search, sortField, sortOrder, group, team, pages = 1) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/users?page='+page + (pages > 1 ? '&pages='+pages : '') + (status != null ? '&status='+status : '') + (search ? '&search='+search : '') + (sortField ? '&sortField='+sortField : '') + (sortOrder !== null ? '&sortOrder='+sortOrder : '') + (group !== null ? '&group='+group : '') + (team !== null ? '&team='+team : ''), requestOptions);
    return res;
}

const userStatus = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/users/status', requestOptions);
    return res;
}

const getPages = async (page, sortField, sortOrder, pages = 1) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/pages?page='+page + (pages > 1 ? '&pages='+pages : '') + (sortField ? '&sortField='+sortField : '') + (sortOrder !== null ? '&sortOrder='+sortOrder : ''), requestOptions);
    return res;
}

const pageStatus = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/pages/status', requestOptions);
    return res;
}

const addPage = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/pages', requestOptions);
    return res;
}

const editPage = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/pages', requestOptions);
    return res;
}

const editInfoPage = async (id) => {
    const res = await authService.handleResponse(apiUrl + '/configuration/pages/?id=' + id, {
        method: 'GET'
    });
    return res;
}

const getPage = async (slug) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/pages?slug=' + slug, requestOptions);
    return res;
}

const saveNav = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/nav', requestOptions);
    return res;
}

const addDiveMode = async (data) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/dive-modes', requestOptions);
    return res;
}

const editDiveMode = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/dive-modes', requestOptions);
    return res;
}

const getDiveModes = async (id) => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/dive-modes', requestOptions);
    return res;
}

const omInfo = async () => {
    const requestOptions = {
        method: 'GET'
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/om', requestOptions);
    return res;
}

const editOm = async (data) => {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(data)
    };

    const res = await authService.handleResponse(apiUrl + '/configuration/om', requestOptions);
    return res;
}

export const confService = {
    addLocation,
    editLocation,
    editInfoLocation,
    locationStatus,
    getLocations,
    addLocationSpecies,
    editLocationSpecies,
    locationSpeciesStatus,
    addTask,
    editTask,
    taskStatus,
    getTasks,
    getUsers,
    userStatus,
    getPages,
    pageStatus,
    addPage,
    editPage,
    editInfoPage,
    getPage,
    saveNav,
    addDiveMode,
    editDiveMode,
    getDiveModes,
    omInfo,
    editOm
};